export const environment = {
    production: false,
    zisApiBaseUrl: 'https://zenithapi-uat.zis.com/api/',
    cookieDomain: '.zis.com',
};